import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
// mui
import { Stack, Grid, FormControl, Select, MenuItem, InputLabel, TextField, Tooltip, IconButton, Button, OutlinedInput, Checkbox, ListItemText } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// components
import CustomAutoComplete from '../customautocomplete/customautocomplete';
import Iconify from '../iconify';
import GlobalFilter from './globalfilter';
import ExportToExcelButton from '../exporttoexcelbutton';
import { ACCESSABLE_VALUE } from '../../auth/utils';
import '../../theme/jjcore.Module.css';
// --------------------------------------------------------------------------------------------------------

CommonFilterToolbar.propTypes = {
    rowData: PropTypes.array,
    columnData: PropTypes.array,
    loading: PropTypes.bool,
    selectedDate: PropTypes.object,
    handleDateChange: PropTypes.func,
    handleRegion: PropTypes.func,
    region: PropTypes.array,
    regionData: PropTypes.array,
    handleFranchise: PropTypes.func,
    franchise: PropTypes.string,
    franchiseData: PropTypes.array,
    open: PropTypes.bool,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    setRegion: PropTypes.func,
    buttonsVisibility: PropTypes.object,
    handleApplyRequestFilter: PropTypes.func,
    handleApplyReset: PropTypes.func,
    ClearFilters: PropTypes.func,
    setRemoveFilter: PropTypes.func,
    globalFilter: PropTypes.string,
    setGlobalFilter: PropTypes.func,
    setLoading: PropTypes.func,
    dataModeList: PropTypes.array,
    dataMode: PropTypes.string,
    handleDataMode: PropTypes.func,
    selectedFranchise: PropTypes.array,
    selectedDataMode: PropTypes.array,
    noMaxDate: PropTypes.bool,
};
// ----------------------------------------------------------------------------------------------------------------

export default function CommonFilterToolbar({ rowData, columnData, loading, selectedDate, handleDateChange,
    regionData, region, handleRegion, franchiseData, handleFranchise, setRegion, open, onOpen,
    onClose, ClearFilters, globalFilter, setGlobalFilter, setLoading, buttonsVisibility, handleApplyReset,
    handleApplyRequestFilter, dataModeList, handleDataMode, selectedFranchise, selectedDataMode, noMaxDate }) {

    const loggedInUserDetails = useSelector(state => state.userdetails.userValue);
    const dataUploadApprovePageAccess = loggedInUserDetails?.DataUploadApprovePageAccess?.[0];
    const reportPageAccess = loggedInUserDetails?.ReportPageAccess?.[0];
    const distributorConfigurationPageAccess = loggedInUserDetails?.DistributorConfigurationPageAccess?.[0];
    const dateView = dataUploadApprovePageAccess?.DateView || reportPageAccess?.ReportDateView || '1';
    const hasDate = dataUploadApprovePageAccess?.HasDate || reportPageAccess?.HasReportDate || '1';
    const franchiseView = dataUploadApprovePageAccess?.FranchiseView || reportPageAccess?.ReportFranchiseView || '1';
    const hasFranchise = dataUploadApprovePageAccess?.HasFranchise || reportPageAccess?.HasReportFranchise || '1';
    const regionView = dataUploadApprovePageAccess?.RegionView || reportPageAccess?.ReportRegionView || '1';
    const hasRegion = dataUploadApprovePageAccess?.HasRegion || reportPageAccess?.HasReportFranchise || '1';
    const dataModeView = distributorConfigurationPageAccess?.DataModeView ?? '1';
    const hasDataMode = distributorConfigurationPageAccess?.HasDataMode ?? '1';

    return (
        <>
            <Grid container item xs={12} sm={12} md={12} lg={12} sx={{ px: 1, pb: 0.4, mt: 0.4 }}>
                <Stack direction={{ xs: "column", md: "row" }} alignItems="center" justifyContent="space-between" flexGrow={1} >
                    <Grid container item xs={12} sm={12} md={6} lg={5} alignItems="center" >
                        <Stack direction="row" alignItems="center" justifyContent="flex-start" flexGrow={1} spacing={1} >
                            {selectedDate && dateView === ACCESSABLE_VALUE &&
                                <Grid item xs={3.5} sm={3} md={2.5} lg={3}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            className={dateView !== ACCESSABLE_VALUE ? '' : 'ExtendedGridFilters'}
                                            label="Month"
                                            inputFormat="MMM-yyyy"
                                            views={['month', 'year']}
                                            value={selectedDate}
                                            onChange={handleDateChange}
                                            openTo="month"
                                            maxDate={noMaxDate ? undefined : new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0) || new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)}
                                            disabled={hasDate !== ACCESSABLE_VALUE}
                                            renderInput={(params) => <TextField size="small" {...params} />}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                            }
                            {(franchiseView === ACCESSABLE_VALUE && franchiseData) &&
                                <Grid item xs={3.5} sm={3} md={2.5} lg={3}>
                                    {/* <FormControl fullWidth
                                        className={hasFranchise !== ACCESSABLE_VALUE ? '' : 'ExtendedGridFilters'}
                                    >
                                        <InputLabel>Franchise</InputLabel>
                                        <Select name="franchise" label="Franchise" size='small'
                                            disabled={hasFranchise !== ACCESSABLE_VALUE}
                                            value={franchise || ''} onChange={handleFranchise}>
                                            {franchiseData?.map((data) => (
                                                <MenuItem key={data.franchise} value={data.franchise}>
                                                    {data.franchise}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>  */}
                                    <FormControl size="small" sx={{ width: '100%' }}>
                                        <InputLabel>Franchise</InputLabel>
                                        <Select
                                            multiple
                                            disabled={hasFranchise !== ACCESSABLE_VALUE}
                                            value={selectedFranchise}
                                            onChange={handleFranchise}
                                            input={<OutlinedInput label="Franchise" />}
                                            renderValue={(selected) => {
                                                if (selected.includes('0') || selected.length === franchiseData.length) {
                                                    return "All";
                                                }
                                                return franchiseData
                                                    .filter((data) => selected.includes(String(data.franchise)))
                                                    .map((data) => data.franchise)
                                                    .join(', ');
                                            }}
                                        >
                                            <MenuItem key="0" value="0">
                                                <Checkbox
                                                    checked={selectedFranchise.length === franchiseData.length}
                                                    indeterminate={selectedFranchise.length > 0 && selectedFranchise.length < franchiseData.length}
                                                />
                                                <ListItemText primary="All" />
                                            </MenuItem>
                                            {franchiseData.map((data) => (
                                                <MenuItem key={data.franchise} value={String(data.franchise)}>
                                                    <Checkbox checked={selectedFranchise.includes('0') || selectedFranchise.includes(String(data.franchise))} />
                                                    <ListItemText primary={data.franchise} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            }
                            {(regionView === ACCESSABLE_VALUE && regionData) &&
                                <Grid item xs={3.5} sm={3} md={2.5} lg={3}>
                                    <CustomAutoComplete optionData={Array.isArray(regionData) ? regionData : []}
                                        setEmptyData={setRegion} orignalArray={region} handleOnChange={handleRegion}
                                        label="Region" DisplayExrp='region' ValueExrp='region' open={open}
                                        onOpen={onOpen} onClose={onClose} hasAccess={hasRegion} heightD="28px" />
                                </Grid>
                            }
                            {(dataModeView === ACCESSABLE_VALUE && dataModeList) &&
                                <Grid item xs={6} sm={3.5}>
                                    {/*   <FormControl fullWidth>
                                        <InputLabel>Data Mode</InputLabel>
                                        <Select name="dataMode" label="Data Mode" size='small' fullWidth
                                            disabled={hasDataMode !== ACCESSABLE_VALUE}
                                            value={dataMode || ''} onChange={handleDataMode}>
                                            {dataModeList.map((mode) => (
                                                <MenuItem key={mode.id} value={mode.id}>
                                                    {mode.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>  */}
                                    <FormControl size="small" sx={{ width: '100%' }}>
                                        <InputLabel>Data Mode</InputLabel>
                                        <Select
                                            multiple
                                            disabled={hasDataMode !== ACCESSABLE_VALUE}
                                            value={selectedDataMode}
                                            onChange={handleDataMode}
                                            input={<OutlinedInput label="DataMode" />}
                                            renderValue={(selected) => {
                                                if (selected.length === dataModeList.length) {
                                                    return "All";
                                                }
                                                return dataModeList
                                                    .filter((data) => selected.includes(String(data.id)))
                                                    .map((data) => data.name)
                                                    .join(', ');
                                            }}
                                        >
                                            <MenuItem key="ALL" value="ALL">
                                                <Checkbox
                                                    checked={selectedDataMode.length === dataModeList.length}
                                                    indeterminate={selectedDataMode.length > 0 && selectedDataMode.length < dataModeList.length}
                                                />
                                                <ListItemText primary="All" />
                                            </MenuItem>
                                            {dataModeList.map((data) => (
                                                <MenuItem key={data.id} value={String(data.id)}>
                                                    <Checkbox checked={selectedDataMode.includes(String(data.id))} />
                                                    <ListItemText primary={data.name} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>}
                            {(selectedDate || franchiseData || regionData || dataModeList) &&
                                <>
                                    {buttonsVisibility?.apply && (
                                        <Grid item xs={0.5} >
                                            <Tooltip title="Apply filter">
                                                <IconButton onClick={handleApplyRequestFilter} disabled={loading}>
                                                    <Iconify
                                                        icon="material-symbols:lock-reset-sharp"
                                                        className="HomePageIconStyle"
                                                    />
                                                </IconButton>
                                            </Tooltip>
                                        </Grid>
                                    )}
                                    {buttonsVisibility?.reset && (
                                        <Grid item xs={0.5} >
                                            <Tooltip title="Reset filter">
                                                <IconButton onClick={handleApplyReset} disabled={loading}>
                                                    <Iconify
                                                        icon="carbon:filter-reset"
                                                        className="HomePageIconStyle"
                                                    />
                                                </IconButton>
                                            </Tooltip>
                                        </Grid>
                                    )}
                                </>
                            }
                        </Stack>
                    </Grid>
                    <Grid container item xs={12} sm={12} md={7} lg={9} alignItems="center">
                        <Stack direction="row" alignItems="center" justifyContent={{ xs: "flex-start", md: "flex-end" }} flexGrow={1} spacing={1} sx={{ mb: { xs: 0.5, md: 0 }, mr: 0.5 }} >
                            <Grid item xs={2.3} sm={1.8} md={2.3} lg={1.7}>
                                <Button className='buttonStyle' variant='contained' size="small"
                                    onClick={ClearFilters} disabled={loading}>
                                    Clear Filters
                                </Button>
                            </Grid>
                            <Grid item xs={5}>
                                <GlobalFilter
                                    value={globalFilter ?? ''}
                                    onChange={value => setGlobalFilter(String(value))}
                                    // sx={{ fontSize: '0.56rem', width: { xs: '75px', sm: '150px', md: '200px', } }}
                                    className='globalFilters'
                                    placeholder="Search..."
                                    setLoading={setLoading}
                                    loading={loading}
                                    disabled={loading}
                                />
                            </Grid>
                            <Grid item xs={1.5} sm={1.2} md={1.5} lg={1.2}>
                                <ExportToExcelButton rowData={rowData} columnData={columnData} />
                            </Grid>
                        </Stack>
                    </Grid>
                </Stack>
            </Grid>
        </>
    );
}